import { api } from './index';

export interface RejectMessageFormData {
  reason: string,
  message?: string,
}

export interface ProductBookingFormData {
  productId: number;
  startDate: string;
  endDate: string;
  amount: number;
  depositAmount: number;
  serviceCost: number;
  currentStatus: string;
  addressId: number;
  shippingMethod: string;
  rejectMessage?: RejectMessageFormData;
  clientLocation: google.maps.LatLngLiteral;
  partnerLocation: google.maps.LatLngLiteral;
  canceled: boolean;
  canceledBy: 'partner' | 'client';
  quantity: number;
  promotionalCodeId: number;
}

export const productBookingsApi = {
  index(status: string, accountType: 'partner'|'client') {
    const path = `/api/internal/product_bookings?status=${status}&account_type=${accountType}`;

    return api({
      method: 'get',
      url: path,
    }).then(response => response.data.productBookings as ProductBooking[]);
  },
  create(data: Partial<ProductBookingFormData>) {
    const path = '/api/internal/product_bookings';

    return api({
      method: 'post',
      url: path,
      data,
    }).then(response => response.data.productBooking as ProductBooking);
  },
  update(id:number, data: Partial<ProductBookingFormData>) {
    const path = `/api/internal/product_bookings/${id}`;

    return api({
      method: 'patch',
      url: path,
      data,
    });
  },
  location(id: number, accountType: 'partner'|'client') {
    const path = `/api/internal/product_bookings/${id}/location?account_type=${accountType}`;

    return api({
      method: 'get',
      url: path,
    }).then(response => response.data);
  },
};
